export const AppPlatform = {
	LP: "landing_page",
	TT: "top_ten",
	AA: "ask_around",
};

export const VETTED_PLACES_WORLDWIDE = "272k";